export default "__VITE_ASSET__c80de1e4__"